import { render, staticRenderFns } from "./ShopByStyleTile.vue?vue&type=template&id=2300efa7&scoped=true&"
import script from "./ShopByStyleTile.vue?vue&type=script&lang=js&"
export * from "./ShopByStyleTile.vue?vue&type=script&lang=js&"
import style0 from "./ShopByStyleTile.vue?vue&type=style&index=0&id=2300efa7&prod&lang=postcss&scoped=true&"
import style1 from "./ShopByStyleTile.vue?vue&type=style&index=1&id=2300efa7&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300efa7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
